import React, { useContext } from 'react';
import { ShopperContext } from '../context/shopper';
import { useUtils } from "../hooks/useUtils";
import { useParams, useNavigate } from 'react-router-dom';
import { BackButton } from './BackButton';
import { HeadingBuilder } from './HeadingBuilder';
import { useTranslation } from "react-i18next";
import * as Constants from '../constants';

export const TripCloneForm = () => {
    const { signedIn, shopper, circleShoppers,
            trips } = useContext(ShopperContext);
    console.log('tcf circleShoppers: ', circleShoppers)

    const navigate = useNavigate();

    const { is_shopper_a_circle_admin, toMmmDdYyyy, toHmmA, } = useUtils();

    const {id} = useParams();
    console.log('tcf id: ', id)

    const { t } = useTranslation();

    const tripObj = trips.find(t => t.id == id);
    console.log('tcf tripObj: ', tripObj)

    if (tripObj == null) {
      console.log('tcf tripObj2: ', tripObj)
      // User likely used browser to refresh the page, lost access to state.
      // This causes 'tripObj' to be 'undefined'.
      // Let's go back to the 'trips' page.
      window.location.replace('/trips/');
    }

    async function duplicateTrip(tripId, assignFlag) {
      const response = await fetch(`/api/trips/${tripId}/duplication`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ assign_nonzero_abs_amounts: assignFlag }),
      });
    
      const data = await response.json();
      console.log(data);

      // Let's navigate to safer ground:
      navigate('/', {replace: true});

      // Refresh to update state
      navigate(0);
      // The effect is clumsy. It takes a long time and its not intuitive why
      // we did not land back on the '/trips/' page.

      // I would have thought this next line would cause the browser to start
      // showing '/trips/' but the view remains fixed at '/'.
      // And yet without this line, we see an ugly error upon clicking a Back
      // button. (We have just deleted a trip so that going to a url for a
      // nonexistent trip fails.)

      // Helpfully, if shopper clicks Back while now viewing '/', this line 
      // causes the '/trips/' view to display.
      navigate('/trips/', {replace: true});

      // Surprise! Doing another 'navigate(0)' causes browser to show '/trips/'
      navigate(0);
    }

    const if_shopper_is_circle_admin = is_shopper_a_circle_admin({
      cShoppers: circleShoppers, circle_id: tripObj.circle.id, shopper_id: shopper.id
    });

    if (signedIn && if_shopper_is_circle_admin) {
      return (
        <article>
          <HeadingBuilder
            Size        = 'h3'
            headingText = {t('trip.formPart.headlineCloneTrip')}
            value       = {tripObj.label}
            // Clone Trip: Publix
          />
          {/* TODO: date info is same as in TripDeleteForm, so standardize? */}
          { toMmmDdYyyy({dateString: tripObj.day, weekday: 'short'})
            }, { toHmmA({timeString: tripObj.hour}) }
          <br/>
          <br/>
          <HeadingBuilder
            Size = 'h1'
            headingText    = {t('trip.formPart.subheadCloneTrip')}
            // Clone the Trip's OrderItems
            tippyAlertText = {t('trip.cloneTripButton.tripCloneDescription')}
            tippyText      = {Constants.DOT}
          />
          <br/>
          <HeadingBuilder
            headingText    = {t('trip.formPart.headingCloneWithZero')}
            // Clone with initial order quantities of 0
            buttonAction   = {() => duplicateTrip(tripObj.id, false)}
            goButtonText   = {Constants.GET_ICON_RT_ARROW}
            tippyAlertText = {t('trip.cloneTripButton.cloneWithZero')}
            tippyText      = {Constants.DOT}
          />
          <br/>
          <HeadingBuilder
            headingText    = {t('trip.formPart.headingCloneWithMatch')}
            // Duplicate everyones' current order quantities
            buttonAction   = {() => duplicateTrip(tripObj.id, true)}
            goButtonText   = {Constants.GET_ICON_RT_ARROW}
            tippyAlertText = {t('trip.cloneTripButton.cloneWithMatch')}
            tippyText      = {Constants.DOT}
          />
          <br/>
          <BackButton />
        </article>
      )
    } else {
      return (
        <HeadingBuilder
          Size = 'h3'
          headingText = {t('global.notSignedInMessage')}
          // Not Authorized - Please Sign in or Sign up
        />
      )
    }
}

export default TripCloneForm;